<template>
  <OmtLayoutContainer
    bg="#F6F6F9"
    :minHeight="['initial', 'calc(100vh - 80px)']"
  >
    <OmtRow v-if="avaliacao">
      <CFlex
        flexDirection="column"
        width="100%"
        justify="space-between"
        minHeight="calc(100vh - 140px)"
        mt="16px"
      >
        <CBox width="100%">
          <OmtTypography
            as="h1-large"
            color="var(--colors-light-primary-dark-blue)"
            mb="8px"
            lineHeight="28px"
          >
            Protocolo: {{ avaliacao.ProtocoloANS }}
          </OmtTypography>
          <OmtTypography
            as="p2"
            color="var(--colors-light-primary-gray2)"
            mb="16px"
          >
            Solicitada em {{ avaliacao.DataInclusao }}
          </OmtTypography>
          <StatusTile
            v-chakra
            mb="32px"
            :label="avaliacao.Status"
            :color="statusColor"
          />

          <!-- Imagem enviada para a análise -->
          <CImage
            v-if="imagemUrl"
            :src="imagemUrl"
            alt="Imagem enviada para análise"
            width="20%"
            borderRadius="8px"
            mb="16px"
          />

          <!-- Em analise: o resultado so aparece com o relatorio final -->
          <CBox
            v-if="pendente"
            bg="#FFFFFF"
            border="1px solid #DADADA"
            borderRadius="8px"
            p="20px"
          >
            <OmtTypography
              as="h2-bold"
              color="var(--colors-light-primary-navy-blue)"
              mb="14px"
            >
              Em análise
            </OmtTypography>
            <OmtTypography
              as="p1"
              color="#4E4E4E"
              fontSize="14px"
              lineHeight="20px"
            >
              O resultado da sua análise será disponibilizado em breve.
            </OmtTypography>
          </CBox>

          <WellnessReport
            v-else-if="relatorio"
            :relatorio="relatorio"
          />

          <OmtTypography
            v-else
            as="p1"
            color="var(--colors-light-primary-gray2)"
          >
            O resultado desta análise ainda não está disponível.
          </OmtTypography>
        </CBox>
      </CFlex>
    </OmtRow>

    <OmtRow v-else-if="error">
      <OmtTypography
        as="p1"
        color="var(--colors-light-primary-gray2)"
        mt="16px"
      >
        {{ error }}
      </OmtTypography>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CFlex, CBox, CImage } from "@chakra-ui/vue";
import StatusTile from "@/components/Organisms/Requests/StatusTile";
import WellnessReport from "@/components/Organisms/Wellness/WellnessReport.vue";

// CodigoStatus da analise ja com o relatorio final.
const CODIGO_STATUS_CONCLUIDA = "C";

export default {
  name: "SkiniverDetail",
  components: { CFlex, CBox, CImage, StatusTile, WellnessReport },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      error: null
    };
  },
  computed: {
    ...mapState("skiniver", ["chamados"]),
    avaliacao() {
      return (this.chamados || []).find(a => String(a.Id) === this.id) || null;
    },
    pendente() {
      return this.avaliacao?.CodigoStatus !== CODIGO_STATUS_CONCLUIDA;
    },
    imagemUrl() {
      // A imagem fica guardada pela Skinive; e a url que vem no proprio retorno da analise.
      return this.avaliacao?.Analise?.image_url || "";
    },
    relatorio() {
      // RetornoFinal guarda a decisao da Plataforma Wellness inteira; o conteudo fica em "report".
      if (!this.avaliacao?.RetornoFinal) return null;
      try {
        return JSON.parse(this.avaliacao.RetornoFinal)?.report || null;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    statusColor() {
      return !this.pendente ? "var(--colors-light-support-success)" : "var(--colors-light-support-warning)";
    }
  },
  async mounted() {
    if (this.avaliacao) {
      this.$root.$emit("hide-loading");
      return;
    }

    this.$root.$emit("show-loading");
    try {
      await this.listChamados();
      if (!this.avaliacao) {
        this.error = "Análise não encontrada";
      }
    } catch (error) {
      console.error(error);
      this.error = "Serviço temporariamente indisponível";
    } finally {
      this.$root.$emit("hide-loading");
    }
  },
  methods: {
    ...mapActions("skiniver", ["listChamados"])
  }
};
</script>
